export default __webpack_public_path__ + "static/media/logo_inap_guatemala.af89b2a5.png";